import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="mt-7 flex flex-col items-center" role="timer" aria-live="off" data-id="element-338" data-mp="1ogerllt0jsz9">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-brand-100" : "text-brand-700"}`} data-id="element-339" data-mp="1jgsbn4lsvymr">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-340" data-mp="1xhl8vx3hl7tk" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-341" data-mp="1td55q3l9cei1">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-342" data-mp="38tm5tzai82ke" data-mpi={i}>
            {i > 0 && <span className={`pt-3 font-serif text-3xl font-black sm:text-4xl ${dark ? "text-white" : "text-brand-900"}`} data-id="element-343" data-mp="34sk1x55n72c3">:</span>}
            <div className="flex flex-col items-center" data-id="element-344" data-mp="2c9rkgkwdqvxl">
              <span className={`flex h-[72px] w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-black tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? "bg-white text-brand-900" : "bg-brand-900 text-white"}`} data-id="element-345" data-mp="2h5p3x02xwiel">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase tracking-wide ${dark ? "text-brand-100" : "text-ink/60"}`} data-id="element-346" data-mp="1tfcl2u65p198">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}